module.exports = __webpack_public_path__ + "1b551172.png";